import { useFetcher } from "~/hooks/useFetcher";
import { type AgentList, AgentScope, agentByNamePath } from "~/services/agents";

/**
 * Resolves the UUID of the SYSTEM agent with the given `name` (e.g.
 * "legacy-dataset-assistant") through an exact-name lookup.
 *
 * The dataset assistant resolves this up front and threads it into
 * createConversation, so new conversations persist `agent_id` rather than
 * relying on the orchestrator mapping `app_id` to an agent at turn time (the
 * fallback while the lookup is in flight). The resolved id also tells the
 * connector picker whose granted connectors to fetch.
 *
 * A lookup rather than a browse scan: browse returns project agents only, and
 * this product's agent is not one.
 *
 * Returns null while the lookup is in flight and when no SYSTEM agent matches.
 */
export function useSystemAgentId(name: string | null): string | null {
  const { data } = useFetcher<AgentList>(name ? agentByNamePath(name) : null);
  return data?.items.find((agent) => agent.scope === AgentScope.SYSTEM)?.id ?? null;
}
